import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ClaimContainer from '../containers/claim/claimContainer';
import SubmittedClaimContainer from '../containers/submittedClaimContainer/submittedClaimContainer';
import ClaimsListContainer from '../containers/claimsListContainer/claimsListContainer';
import ExistingClaimContainer from '../containers/existingClaim/existingClaimContainer';
import withAuthentication from '../hocs/withAuthentication';

const AuthenticatedUserRouter = props => {
    return (
        <Switch>
            <Route exact path="/claims/list" component={ClaimsListContainer} />
            <Route
                exact
                path="/claim/:id/submitted"
                component={SubmittedClaimContainer}
            />
            <Route
                exact
                path={[
                    '/claims/:id/template/:templateId',
                    '/claims/:id/:path',
                    '/claims/:id',
                ]}
                component={ExistingClaimContainer}
            />
            <Route
                path={[
                    `/claim/:refillClaimId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})?`,
                    '/claim',
                ]}
                component={ClaimContainer}
            />
            <Route path="/" render={() => <Redirect to={'/claim'} />} />
        </Switch>
    );
};

export default withAuthentication(AuthenticatedUserRouter);
